import { render, staticRenderFns } from "./PressTable.vue?vue&type=template&id=5e1fcd0f&scoped=true&"
import script from "./PressTable.vue?vue&type=script&lang=js&"
export * from "./PressTable.vue?vue&type=script&lang=js&"
import style0 from "./PressTable.vue?vue&type=style&index=0&id=5e1fcd0f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fcd0f",
  null
  
)

export default component.exports